/* eslint-disable prettier/prettier */
import React, { useCallback } from 'react';

import useOutsideClick from 'hooks/useOutsideClick';
import { CostCenter } from 'models/costCenter';

import { Container, Items, Item } from './styles';

interface Product {
  label: string;
  value: string;
}

interface Props {
  show: boolean;
  value: any;
  products?: Product[];
  costCenters?: CostCenter[];
  selectRef: React.RefObject<HTMLDivElement>;
  onChange: (value: string) => void;
  onClose: () => void;
}

interface MakeItemProps {
  className: string;
  text: string;
  onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
}

const MakeItem = ({ text, ...rest }: MakeItemProps) => <Item {...rest}>{text}</Item>;

const SelectGroups = ({ show, costCenters, products, selectRef, value, onChange, onClose }: Props) => {
  useOutsideClick(selectRef, onClose);

  const isCostCenterActive = useCallback((item: CostCenter) => item.id === value, [value]);

  const isProductActive = useCallback((item: Product) => item.value === value, [value]);

  const handleItemClick = (id: string) => {
    if (id !== value) {
      onChange(id);
    }
    onClose();
  };

  const makeCostCenter = (costCenter: CostCenter) => `${costCenter.code ?? ''} ${costCenter.code ? '-' : ''} ${costCenter.name ?? ''}`;

  const makeProduct = (product: Product) => product.label;

  return show ? (
    <Container>
      <Items>
        {costCenters
          ? costCenters.map((c) => (
            <MakeItem
              key={c.id}
              className={isCostCenterActive(c) ? 'active' : ''}
              text={makeCostCenter(c)}
              onClick={() => handleItemClick(c?.id ?? '')}
            />
          ))
          : products &&
          products.map((p) => (
            <MakeItem
              key={p.value}
              className={isProductActive(p) ? 'active' : ''}
              text={makeProduct(p)}
              onClick={() => handleItemClick(p.value || '')}
            />
          ))}
      </Items>
    </Container>
  ) : null;
};

export default SelectGroups;
